import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PlainChat } from '@/components/chat/plain-chat'
import { ConditionalTrialBanner } from './-components/conditional-trial-banner'
import { AppSidebar } from './-components/app-sidebar/app-sidebar'
import { SidebarProvider } from '@/components/ui/sidebar'
import { SiteHeader } from './-components/site-header'
import { TamReadyWatcher } from './-components/tam-ready-watcher'

function FrontendLayout() {
  return (
    <div className="flex h-screen flex-col overflow-y-auto">
      <SidebarProvider className="min-h-0 flex-1 overflow-y-auto">
        <div className="flex min-h-0 flex-1 w-full overflow-y-auto">
          <div className="flex-none">
            <AppSidebar />
          </div>
          <div className="flex min-h-0 min-w-0 flex-1 flex-col">
            <SiteHeader />
            <ConditionalTrialBanner />
            <main className="flex min-h-0 min-w-0 flex-1 flex-col gap-2 overflow-y-auto">
              <div className="flex min-h-0 min-w-0 flex-1 flex-col">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
        <PlainChat />
        <TamReadyWatcher />
      </SidebarProvider>
    </div>
  )
}
export const Route = createFileRoute('/_authed/_user')({
  component: FrontendLayout,
})
